module.exports = __webpack_public_path__ + "static/media/rc-medical-malpractice-icon.a6775a00.svg";